import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import Layout from 'sushiweb/Layout';
import Breadcrumb from 'sushiweb/Breadcrumb/Breadcrumb';
import H5 from 'sushiweb/Typography/Heading/H5';
import Plus from 'sushiweb/Icons/all/Plus';
import Button from 'sushiweb/Button/Button';
import HorizontalTabs from 'sushiweb/HorizontalTabs/HorizontalTabs';
import {
  BreadCrumbWrapper,
  ConsumptionHeadWrapper,
  DashboardWrapper,
  LayoutContainers,
  TabContainer,
  TabHeadWrapper,
  TabWrapper,
  tabStyle,
} from '../common/styles';
import DetailsWrapper from '../common/components/DetailsWrapper/DetailsWrapper';
import {
  emptyDashboardStateMessage,
  emptyDashboardStateTitle,
} from '../../constants';
import CreateGroupModal from '../common/components/CreateGroupModal';
import UpcomingTopups from './UpcomingTopups';
import PreviousTopups from './PreviousTopups';
import ErrorPage from '../common/components/ErrorPage';
import {
  DASHBOARD,
  REFRESH_LABEL,
  amountBlockedInfo,
  amountDisbursedInfo,
  applicableFlowTypes,
  businessTypeEnum,
  currentBalanceInfo,
  currentFlowTypeEnum,
  limitConsumedInfo,
  onboardedEmployeeInfoHomePage,
  onboardingPendingInfo,
  ordersPlacedInfo,
} from '../common/components/constants';
import EmptyStateV2 from '../common/components/EmptyStateV2/EmptyStateV2';
import { formatAmountInRupees } from '../../helpers';
import Banner from '../common/components/Banner';
import Consumptions from './Consumptions';
import MonthFilter from './Consumptions/MonthFilter';
import ZTrackingClient from '../../jumbo/ZTrackingClient';
import { NewTagDiv } from '../common/components/SideNavbar/styles';
import zfetch, { METHOD_GET } from '../common/utils/zfetch';
import { GET_CONSUMPTION_DETAILS } from '../../constants/urls';

const Dashboard = ({
  currentFlow,
  selectedWorkspace,
  getLandingPageDetails,
  landingPageInfo,
  fetchinglandingPage,
  fetchedlandingPage,
  viewOnlyMode,
}) => {
  localStorage.activeIndexDashboard =
    localStorage.activeIndexDashboard !== undefined
      ? Number(localStorage.activeIndexDashboard)
      : 1;
  const isEmployeesAdded = landingPageInfo?.is_employees_added ?? false;
  const [createGroupModalVisible, setCreateGroupModalVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(
    localStorage.activeIndexDashboard !== undefined
      ? Number(localStorage.activeIndexDashboard)
      : 0,
  );
  const [consumptionActiveIndex, setConsumptionActiveIndex] = useState(0);
  const [currentMonthSelected, setCurrentMonthSelected] = useState(true);
  const [lastMonthSelected, setLastMonthSelected] = useState(false);
  const [reqStartDate, setReqStartDate] = useState('');
  const [reqEndDate, setReqEndDate] = useState('');
  const [businessType, setBusinessType] = useState(
    businessTypeEnum.BUSINESS_TYPE_ONLINE_ORDERING,
  );
  const [isDiningOrders, setIsDiningOrders] = useState(false);

  const handleTabsClick = val => () => {
    setActiveIndex(val);
    localStorage.activeIndexDashboard = Number(val);
  };

  const handleConsumptionTabsClick = val => () => {
    setConsumptionActiveIndex(val);
    setBusinessType(
      val === 0
        ? businessTypeEnum.BUSINESS_TYPE_ONLINE_ORDERING
        : businessTypeEnum.BUSINESS_TYPE_DINING,
    );
  };

  useEffect(() => {
    ZTrackingClient.recordImpression({
      ui_source: 'DASHBOARD',
      component: 'SIDE_NAV_BAR',
    });
  }, []);

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id) {
      if (!lastMonthSelected) {
        ZTrackingClient.recordClick({
          ui_source: 'DASHBOARD',
          component: 'THIS_MONTH_TAB',
        });
      }
      const today = new Date();
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        2,
      );
      const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1,
      );
      let startDate = firstDayOfMonth.toISOString().split('T')[0];
      let endDate = lastDayOfMonth.toISOString().split('T')[0];
      if (lastMonthSelected) {
        ZTrackingClient.recordClick({
          ui_source: 'DASHBOARD',
          component: 'LAST_MONTH_TAB',
        });
        const lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1,
        );
        const firstDayOfLastMonth = new Date(
          lastMonth.getFullYear(),
          lastMonth.getMonth(),
          2,
        );
        const lastDayOfLastMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1,
        );
        [startDate] = firstDayOfLastMonth.toISOString().split('T');
        [endDate] = lastDayOfLastMonth.toISOString().split('T');
      }
      getLandingPageDetails({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
        startDate,
        endDate,
      });
    }
  }, [selectedWorkspace, currentFlow, lastMonthSelected]);

  useEffect(() => {
    if (currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT) {
      const today = new Date();
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        2,
      );
      const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1,
      );
      let startDate = firstDayOfMonth.toISOString().split('T')[0];
      let endDate = lastDayOfMonth.toISOString().split('T')[0];
      if (lastMonthSelected) {
        const lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1,
        );
        const firstDayOfLastMonth = new Date(
          lastMonth.getFullYear(),
          lastMonth.getMonth(),
          2,
        );
        const lastDayOfLastMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1,
        );
        [startDate] = firstDayOfLastMonth.toISOString().split('T');
        [endDate] = lastDayOfLastMonth.toISOString().split('T');
      }
      setReqStartDate(startDate);
      setReqEndDate(endDate);
      fetchConsumptions(startDate, endDate);
    }
  }, [currentFlow, lastMonthSelected]);

  const fetchConsumptions = (startDate, endDate) => {
    zfetch(GET_CONSUMPTION_DETAILS, {
      method: METHOD_GET,
      params: {
        business_type: businessTypeEnum.BUSINESS_TYPE_DINING,
        start_date: startDate,
        end_date: endDate,
        exclusive_start_key: '',
        page_size: 10,
        order_status: '',
      },
    })
      .then(res => res.json())
      .then(response => {
        const { data: consumption } = response;
        if (currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT) {
          if (consumption && consumption.length > 0) {
            setIsDiningOrders(true);
          }
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  const refreshPage = () => {
    getLandingPageDetails({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlow,
    });
  };

  const closeCreateGroupModal = () => {
    setCreateGroupModalVisible(false);
  };

  const handleAddEmployeeClick = () => {
    setCreateGroupModalVisible(true);
  };

  const showSelectedTable = () => {
    if (activeIndex === 0) return <UpcomingTopups />;
    return <PreviousTopups />;
  };

  const ActionComponent = () => {
    return (
      <div>
        <Button
          icon={<Plus />}
          iconAlign='left'
          onClick={() => handleAddEmployeeClick()}
        >
          Add employees
        </Button>
      </div>
    );
  };

  if (!fetchedlandingPage && !fetchinglandingPage) {
    return (
      <DashboardWrapper>
        <ErrorPage
          showAction
          actionLabel={REFRESH_LABEL}
          clickAction={refreshPage}
        />
      </DashboardWrapper>
    );
  }

  return !fetchinglandingPage && !isEmployeesAdded ? (
    <div>
      {createGroupModalVisible && (
        <CreateGroupModal
          currentTab={DASHBOARD}
          closeModal={closeCreateGroupModal}
          isVisible={createGroupModalVisible}
          heading='Create new team'
        />
      )}
      <EmptyStateV2
        state={DASHBOARD}
        title={emptyDashboardStateTitle}
        message={emptyDashboardStateMessage}
        actionComponent={ActionComponent}
      />
    </div>
  ) : (
    <DashboardWrapper>
      {viewOnlyMode && <Banner />}
      <BreadCrumbWrapper>
        <Breadcrumb>
          <Breadcrumb.Link
            style={{
              color: 'var(--coolgreycoolgrey-400, #AFB4C0)',
            }}
          >
            Home
          </Breadcrumb.Link>
        </Breadcrumb>
      </BreadCrumbWrapper>
      <TabHeadWrapper>
        <H5>Summary</H5>
      </TabHeadWrapper>
      {currentFlow === currentFlowTypeEnum.FLOW_TYPE_PPI ? (
        <LayoutContainers>
          <Layout gap={20}>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={currentBalanceInfo}
                label='Current balance'
                value={formatAmountInRupees(landingPageInfo.current_balance)}
                loading={fetchinglandingPage}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={amountBlockedInfo}
                label='Amount parked'
                value={formatAmountInRupees(
                  landingPageInfo.amount_blocked ?? 0,
                )}
                loading={fetchinglandingPage}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={amountDisbursedInfo}
                label='Top-ups done this month'
                value={formatAmountInRupees(landingPageInfo.amount_disbursed)}
                loading={fetchinglandingPage}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={onboardedEmployeeInfoHomePage}
                label='Onboarded'
                value={landingPageInfo.active_employees ?? 0}
                subValue={
                  landingPageInfo.active_employees !== 1
                    ? 'employees'
                    : 'employee'
                }
                loading={fetchinglandingPage}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={onboardingPendingInfo}
                label='Onboarding pending'
                value={landingPageInfo.onboarding_pending ?? 0}
                subValue={
                  landingPageInfo.onboarding_pending !== 1
                    ? 'employees'
                    : 'employee'
                }
                loading={fetchinglandingPage}
              />
            </Layout.Item>
          </Layout>
        </LayoutContainers>
      ) : (
        <LayoutContainers>
          {isDiningOrders ? (
            <Layout gap={14}>
              {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT && (
                <Layout.Item colD={12} colT={12} colM={12}>
                  <MonthFilter
                    currentMonthSelected={currentMonthSelected}
                    lastMonthSelected={lastMonthSelected}
                    setCurrentMonthSelected={setCurrentMonthSelected}
                    setLastMonthSelected={setLastMonthSelected}
                  />
                </Layout.Item>
              )}
              <Layout.Item colD={3} colT={3} colM={3}>
                <DetailsWrapper
                  tooltipMessage={limitConsumedInfo}
                  label='Budget used'
                  value={formatAmountInRupees(landingPageInfo.amount_consumed)}
                  loading={fetchinglandingPage}
                />
              </Layout.Item>
              <Layout.Item colD={3} colT={3} colM={3}>
                <DetailsWrapper
                  tooltipMessage={ordersPlacedInfo}
                  label='Orders placed'
                  value={landingPageInfo.orders_placed ?? 0}
                  loading={fetchinglandingPage}
                />
              </Layout.Item>
              <Layout.Item colD={3} colT={3} colM={3}>
                <DetailsWrapper
                  tooltipMessage={ordersPlacedInfo}
                  label='Dining bills paid'
                  value={landingPageInfo.dining_transactions ?? 0}
                  loading={fetchinglandingPage}
                />
              </Layout.Item>
              <Layout.Item colD={3} colT={3} colM={3}>
                <DetailsWrapper
                  showInfoTip
                  tooltipDirection='bottomRight'
                  tooltipMessage={`Employees who placed at least one order ${
                    currentMonthSelected ? 'in this month' : 'last month'
                  }`}
                  label='Active employees'
                  value={landingPageInfo.orders_placing_employees ?? 0}
                  subValue={
                    landingPageInfo.orders_placing_employees !== 1
                      ? 'employees'
                      : 'employee'
                  }
                  loading={fetchinglandingPage}
                />
              </Layout.Item>
            </Layout>
          ) : (
            <Layout gap={20}>
              {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT && (
                <Layout.Item colD={12} colT={12} colM={12}>
                  <MonthFilter
                    currentMonthSelected={currentMonthSelected}
                    lastMonthSelected={lastMonthSelected}
                    setCurrentMonthSelected={setCurrentMonthSelected}
                    setLastMonthSelected={setLastMonthSelected}
                  />
                </Layout.Item>
              )}
              <Layout.Item colD={4} colT={4} colM={4}>
                <DetailsWrapper
                  tooltipMessage={limitConsumedInfo}
                  label='Budget used'
                  value={formatAmountInRupees(landingPageInfo.amount_consumed)}
                  loading={fetchinglandingPage}
                />
              </Layout.Item>
              <Layout.Item colD={4} colT={4} colM={4}>
                <DetailsWrapper
                  tooltipMessage={ordersPlacedInfo}
                  label='Orders placed'
                  value={landingPageInfo.orders_placed ?? 0}
                  loading={fetchinglandingPage}
                />
              </Layout.Item>
              <Layout.Item colD={4} colT={4} colM={4}>
                <DetailsWrapper
                  showInfoTip
                  tooltipDirection='bottomRight'
                  tooltipMessage={`Employees who placed at least one order ${
                    currentMonthSelected ? 'in this month' : 'last month'
                  }`}
                  label='Active employees'
                  value={landingPageInfo.orders_placing_employees ?? 0}
                  subValue={
                    landingPageInfo.orders_placing_employees !== 1
                      ? 'employees'
                      : 'employee'
                  }
                  loading={fetchinglandingPage}
                />
              </Layout.Item>
            </Layout>
          )}
        </LayoutContainers>
      )}
      {currentFlow === currentFlowTypeEnum.FLOW_TYPE_PPI ? (
        <TabWrapper>
          <TabContainer>
            <HorizontalTabs
              style={{ marginBottom: '-4.5px' }}
              alignLinks='left'
              additionalGap='1.8rem'
            >
              <HorizontalTabs.Link
                active={activeIndex === 0}
                onClick={handleTabsClick(0)}
                style={{
                  width: '180px',
                  color:
                    activeIndex === 0
                      ? 'var(--coolgreycoolgrey-800, #414A5D)'
                      : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                  ...tabStyle,
                }}
              >
                Upcoming Top-ups
              </HorizontalTabs.Link>
              <HorizontalTabs.Link
                active={activeIndex === 1}
                onClick={handleTabsClick(1)}
                style={{
                  width: '200px',
                  color:
                    activeIndex === 1
                      ? 'var(--coolgreycoolgrey-800, #414A5D)'
                      : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                  ...tabStyle,
                }}
              >
                Past Top-ups
              </HorizontalTabs.Link>
            </HorizontalTabs>
          </TabContainer>
          {showSelectedTable()}
        </TabWrapper>
      ) : (
        <>
          <ConsumptionHeadWrapper>
            <H5>Consumption details</H5>
          </ConsumptionHeadWrapper>
          <TabWrapper>
            {isDiningOrders ? (
              <TabContainer>
                <HorizontalTabs
                  style={{ marginBottom: '-4.5px' }}
                  alignLinks='left'
                  additionalGap='1.8rem'
                >
                  <HorizontalTabs.Link
                    active={consumptionActiveIndex === 0}
                    onClick={handleConsumptionTabsClick(0)}
                    style={{
                      width: '140px',
                      color:
                        consumptionActiveIndex === 0
                          ? 'var(--coolgreycoolgrey-800, #414A5D)'
                          : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                      ...tabStyle,
                    }}
                  >
                    Delivery
                  </HorizontalTabs.Link>
                  <HorizontalTabs.Link
                    active={consumptionActiveIndex === 1}
                    onClick={handleConsumptionTabsClick(1)}
                    style={{
                      width: '200px',
                      color:
                        consumptionActiveIndex === 1
                          ? 'var(--coolgreycoolgrey-800, #414A5D)'
                          : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                      ...tabStyle,
                    }}
                  >
                    Dining 
                    {' '}
                    <NewTagDiv>NEW</NewTagDiv>
                  </HorizontalTabs.Link>
                </HorizontalTabs>
              </TabContainer>
            ) : (
              <></>
            )}
            <Consumptions
              lastMonthSelected={lastMonthSelected}
              reqStartDate={reqStartDate}
              reqEndDate={reqEndDate}
              selectedBusinessType={businessType}
            />
          </TabWrapper>
        </>
      )}
    </DashboardWrapper>
  );
};

Dashboard.propTypes = {
  currentFlow: PropTypes.oneOfType(applicableFlowTypes),
  getLandingPageDetails: PropTypes.func,
  landingPageInfo: PropTypes.objectOf(PropTypes.any),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  fetchinglandingPage: PropTypes.bool,
  fetchedlandingPage: PropTypes.bool,
  viewOnlyMode: PropTypes.bool,
};

Dashboard.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  getLandingPageDetails: _noop,
  landingPageInfo: {},
  selectedWorkspace: {},
  fetchinglandingPage: true,
  fetchedlandingPage: true,
  viewOnlyMode: false,
};

export default Dashboard;
